import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Info, Database, FileText } from 'lucide-react';

/**
 * StudyMethodologyBox — Seção de metodologia para estudos
 *
 * Props:
 *   methodology  — Texto principal da metodologia
 *   dataSource   — Nome/URL da fonte de dados
 *   dataPoints   — Número total de pontos de dados
 *   period       — String do período (ex: "2019–2025")
 *   limitations  — Array de strings com limitações do estudo
 *   defaultOpen  — Aberto por padrão? (default: false)
 */
const StudyMethodologyBox = ({
  methodology,
  dataSource,
  dataPoints,
  period,
  limitations = [],
  defaultOpen = false,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  if (!methodology) return null;

  return (
    <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center gap-2">
          <Info className="w-4 h-4 text-gray-500" />
          <span className="font-bold text-gray-900">Metodologia</span>
        </div>
        {open ? (
          <ChevronUp className="w-4 h-4 text-gray-400" />
        ) : (
          <ChevronDown className="w-4 h-4 text-gray-400" />
        )}
      </button>

      {open && (
        <div className="px-6 pb-6 border-t border-gray-100 pt-4 space-y-4">
          {/* Methodology text */}
          <p className="text-sm text-gray-600 leading-relaxed">{methodology}</p>

          {/* Meta row */}
          <div className="flex flex-wrap items-center gap-4 text-xs text-gray-400">
            {dataSource && (
              <span className="flex items-center gap-1">
                <Database className="w-3 h-3" />
                Fonte: {dataSource}
              </span>
            )}
            {dataPoints && (
              <span className="flex items-center gap-1">
                <FileText className="w-3 h-3" />
                {typeof dataPoints === 'number'
                  ? `${dataPoints.toLocaleString('pt-BR')} pontos de dados`
                  : dataPoints}
              </span>
            )}
            {period && <span>Período: {period}</span>}
          </div>

          {/* Limitations */}
          {limitations.length > 0 && (
            <div className="bg-gray-50 rounded-xl p-4">
              <p className="text-xs font-bold text-gray-500 uppercase tracking-wide mb-2">
                Limitações do estudo
              </p>
              <ul className="list-disc list-inside space-y-1">
                {limitations.map((lim, i) => (
                  <li key={i} className="text-sm text-gray-600">
                    {lim}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default StudyMethodologyBox;
